import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel', 'toggle']
  static values = {
    activeIndex: { type: Number, default: 0 }
  }

  dispatchToggleChange() {
    this.toggleTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }


  close() {
    this.toggleTarget.checked = false
    this.dispatchToggleChange()
  }

  selectTab(event) {
    const tab = event.currentTarget
    const index = this.tabTargets.indexOf(tab)

    if (this.hasToggleTarget && index === this.activeIndexValue && this.toggleTarget.checked) {
      this.toggleTarget.checked = false
      this.dispatchToggleChange()
      tab.setAttribute('data-active', 'false')
      return
    }

    this.activeIndexValue = index
    this.showPanel(index)

    if (this.hasToggleTarget) {
      this.toggleTarget.checked = true
      this.dispatchToggleChange()
    }
  }

  showPanel(index) {
    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })

    this.tabTargets.forEach((tab, i) => {
      this.setTabState(tab, i === index)
    })
  }

  toggleTargetConnected() {
    this.toggleTarget.addEventListener('change', () => {
      if (!this.toggleTarget.checked) {
        this.tabTargets.forEach(tab => this.setTabState(tab, false))
      }
    })
  }

  // aria-selected is only valid on role="tab" (the drawer tablist); plain
  // toggle buttons (ui/tab_bar_item) convey state with aria-pressed instead.
  setTabState(tab, isActive) {
    const ariaAttribute = tab.getAttribute('role') === 'tab' ? 'aria-selected' : 'aria-pressed'
    tab.setAttribute('data-active', isActive ? 'true' : 'false')
    tab.setAttribute(ariaAttribute, isActive ? 'true' : 'false')
  }
}

